import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  ACCESS_DENIED,
  ADMIN_ADD_CREDENTIAL,
  ADMIN_CREDENTIAL,
  VIEW_ADMIN_CREDENTIAL,
} from "../../../constant/routeContant";
import AdminCredential from "../component/adminCredentialList";
import { useDispatch, useSelector } from "react-redux";
import * as credentialAction from "../../../redux/actions/credentialAction";
import { toast, ToastContainer } from "react-toastify";
import { ORG_ID, GRID_DEFAULT_PAGE_SIZE, API_STATUS } from "../../../constant/constant";
import * as adminAction from "../../../redux/actions/adminCommonAction";
import { checkPrivileges } from "../../../utils/rolesHelper";
import { InactiveClient, getUserBaseDivisionInfo } from "../../../utils/helper";
import { getPreviousRoute } from "../../../utils/routeTracker";

function AdminCredentialListContainer() {
  const navigate = useNavigate();
  const [sendEmail, setSendEmail] = useState(false);
  const [shouldRestoreState, setShouldRestoreState] = useState(false);
  const deleteTriggeredRef = useRef(false);
  const { hasBaseDivisionAdminAccess, baseDivisionIds } =
    getUserBaseDivisionInfo();
  const defaultData = {
    userId: 0,
    page: 1,
    search: "",
    pageSize: GRID_DEFAULT_PAGE_SIZE,
    orgId: ORG_ID(),
    credentialType: "",
    userType: 0,
    isSendMail: false,
    divisionId: hasBaseDivisionAdminAccess ? baseDivisionIds : "",
  };

  const userCredentialListData = useSelector(
    (state) => state.getCredentialUserListData,
  );
  const isLoading = userCredentialListData?.isLoading;
  const dispatch = useDispatch();

  const getUserCredentials = (data) => {
    if (data?.isSendMail) {
      setSendEmail(true);
    } else {
      setSendEmail(false);
    }
    dispatch(credentialAction.getUserCredentialList(data));
    dispatch(credentialAction.getUserCredentialsFilterObj(data));
  };

  useEffect(() => {
    const previousRoute = getPreviousRoute();
    const preserveRoutes = [VIEW_ADMIN_CREDENTIAL, ADMIN_ADD_CREDENTIAL];
    const isFromPreserveRoute =
      previousRoute &&
      preserveRoutes.some((r) => previousRoute.startsWith(r)) &&
      sessionStorage.getItem("credentialListPreserveState") === "true";
    sessionStorage.removeItem("credentialListPreserveState");

    if (isFromPreserveRoute && userCredentialListData?.filterObj) {
      setShouldRestoreState(true);
      getUserCredentials(userCredentialListData.filterObj);
    } else {
      setShouldRestoreState(false);
      getUserCredentials(defaultData);
    }
  }, []);

  const dropDownData = useSelector(
    (state) => state.getDropdownDataKeyValue?.data,
  );

  const deleteCredentialReducerData = useSelector(
    (state) => state.deleteCredentialReducerData.status,
  );

  const deleteCredential = (credentialId) => {
    if (InactiveClient()) return;
    deleteTriggeredRef.current = true;
    dispatch(credentialAction.deleteCredential(credentialId));
  };

  useEffect(() => {
    if (
      deleteCredentialReducerData === API_STATUS.SUCCESS &&
      deleteTriggeredRef.current
    ) {
      deleteTriggeredRef.current = false;
      const currentFilter = userCredentialListData?.filterObj || defaultData;
      getUserCredentials(currentFilter);
    }
  }, [deleteCredentialReducerData]);

  const getDropdownDataKeyValueData = {
    orgId: ORG_ID(),
    flags: [8, 6],
  };

  useEffect(() => {
    dispatch(adminAction.getDropdownDataKeyValue(getDropdownDataKeyValueData));
  }, []);

  const navigateAddCredential = () => {
    if (InactiveClient()) return;
    navigate(ADMIN_ADD_CREDENTIAL);
  };

  useEffect(() => {
    if (userCredentialListData?.status === API_STATUS.SUCCESS && sendEmail) {
      toast("User credential has been sent to registered email ID");
    }
  }, [userCredentialListData]);

  return (
    <>
      {checkPrivileges([12, 13, 47, 48]) ? (
        <>
          <ToastContainer />
          <AdminCredential
            navigateAddCredential={navigateAddCredential}
            credentialListData={
              isLoading ? [] : userCredentialListData?.data?.result
            }
            isLoading={isLoading}
            getUserCredentials={getUserCredentials}
            credentialTypes={dropDownData?.credentialTypes}
            deleteCredentials={deleteCredential}
            userCredentialListDatas={userCredentialListData}
            divisionList={dropDownData?.divisons ?? []}
            shouldRestoreState={shouldRestoreState}
            hasBaseDivisionAdminAccess={hasBaseDivisionAdminAccess}
            baseDivisionIds={baseDivisionIds}
          />
        </>
      ) : (
        navigate(ACCESS_DENIED)
      )}
    </>
  );
}

export default AdminCredentialListContainer;
